// extracted by mini-css-extract-plugin
export default {"TermsOfServiceWrapper":"TermsOfServicePage_TermsOfServiceWrapper__xbD2M","TermsOfService":"TermsOfServicePage_TermsOfService__NGo-X"};